import { IDeviceTeleopRosStreamConfiguration } from "@formant/core/model/IDeviceTeleopRosStreamConfiguration";
import { IRtcStream } from "@formant/core/model/IRtcStream";
import { Uuid } from "@formant/core/model/Uuid";
import { teleopRosTopicTypeToRtcStreamType } from "@formant/rtc-client/utils/teleopRosTopicTypeToRtcStreamType";

export function teleopStreamToRtc(
    id: Uuid,
    teleopStream?: IDeviceTeleopRosStreamConfiguration,
): IRtcStream | undefined {
    if (!teleopStream) {
        return undefined;
    }
    const { topicName, topicType, encodeVideo, buttonLabel } = teleopStream;
    return {
        entityId: id,
        streamName: topicName,
        streamType: teleopRosTopicTypeToRtcStreamType(topicType, encodeVideo),
        buttonLabel,
    };
}
